import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
export default function CompanyCard(_ref) {
  let {
    model,
    accountType,
    refreshCompanies,
    CompanyCardActionButtons,
    CompanyCardHeader,
    setLoading,
    type,
    to,
    deleteCompanyGroup
  } = _ref;
  // const claimYears = useMemo(() => model.claim_groups.map((claimGroup) => claimGroup.name.split(' ').pop()).sort((a, b) => a - b), [model]);
  const allClaimYears = [...model.claim_years];
  const claimYears = [allClaimYears.shift(), allClaimYears.pop()].filter(y => !!y);
  return /*#__PURE__*/React.createElement(Card, {
    className: "company-card me-2"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "company-card-header border-0"
  }, /*#__PURE__*/React.createElement(CompanyCardHeader, {
    model: model,
    refreshCompanies: refreshCompanies
  })), /*#__PURE__*/React.createElement(Card.Body, {
    className: "company-card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "company-card-name"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "text-white",
    to: to
  }, model.name)), /*#__PURE__*/React.createElement("div", null, claimYears.length > 1 ? `${claimYears[0]} - ${claimYears[claimYears.length - 1]}` : claimYears[0]), CompanyCardActionButtons && /*#__PURE__*/React.createElement(CompanyCardActionButtons, {
    model: model,
    accountType: accountType,
    setLoading: setLoading,
    refreshCompanies: refreshCompanies,
    type: type,
    deleteCompanyGroup: deleteCompanyGroup
  })));
}